import {
  MouseSign as MouseSignIcon,
  Touch as TouchIcon
} from '@abbott-components/icons';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default () => (
  <Stack direction="column" alignItems="center" spacing={3}>
    <Stack direction="row" alignItems="center" spacing={3}>
      <MouseSignIcon />
      <Typography>Or</Typography>
      <TouchIcon />
    </Stack>
    <Typography>(PLEASE SIGN HERE)</Typography>
  </Stack>
);
